import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { UserService } from './user.service';
import { ModalService } from './modal.service';
import { take, map } from 'rxjs/operators';
import 'rxjs/add/observable/of';

@Injectable()
export class PrivilegeGuard implements CanActivate {
  constructor(
    private router: Router,
    private userService: UserService,
    private modalService: ModalService
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.userService.currentUser.pipe(
      take(1),
      map(user => {
        // Jeśli użytkownik ma uprawnienie tylko do przeglądania nagrań
        if (this.hasOnlyViewRecordingsPrivilege(user)) {
          // Zezwalaj tylko na dostęp do /caregivers/telecare
          if (state.url === '/caregivers/telecare' || state.url.startsWith('/caregivers/telecare')) {
            return true;
          } else {
            // Blokuj dostęp do innych stron i pokaż modal
            this.modalService.openUnauthorized();
            return false;
          }
        }
        // Dla innych użytkowników pozwól na dostęp
        return true;
      })
    );
  }

  private hasOnlyViewRecordingsPrivilege(user: any): boolean {
    if (!user || !user.user_id || !user.user_id.privilege) {
      return false;
    }

    const privileges = user.user_id.privilege.split(';').map(p => p.trim());
    // Sprawdź czy użytkownik ma tylko uprawnienie viewRecordings
    return privileges.includes('viewRecordings') && privileges.length === 1;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/privilege-guard.service.ts